import _ from 'lodash';

function canSee(ctx,what,role,options,permission){

    
   /* var role

    if(roleAssign){
        role = roleAssign
    }else{
        role = ctx.$store.state.userDetails.role 
    }

    */

    
    
    var role = role || ctx.$store.state.userDetails.role 
    var permission = permission || ctx.$store.state.userDetails.permission

    switch(what){

        case "filter" :
            if(role == "User"){
                return false
            }

            var exludeList = ["Setup" , "ResetPassword" , "confirmEmail" , "Bulk Member" , "Bulk Location", "Bulk Holiday" , "Bulk Attendance" , "Subscription" , "Tags", "Groups" , "Shifts" , "Weeklyoff" , "Holiday" , "Locations", "Company" , "Help", "Profile" , "Notifications" , "AddForm" , "EditForm", "Reports" ]
            if(exludeList.includes(ctx.$router.currentRoute.name) ){
                return false
            }
            return true

        break
        
        case "latestCheckin" :
            if(role == "User"){
                return false
            }
            return true

        break

        case "presentCheckinAdminDiv" :
            if(role == "User"){
                return false
            }
            return true

        break

        case "presentCheckinUserDiv" :
            if(role == "User"){
                return true
            }
            return false

        break

        case "changeRole" : 

            if(role == "SuperAdmin"){
                return true
            }else if(role == "Admin"){

                
                if(typeof options !="undefined" && _.some(permission, {name:"modifyUser" }) && options.recepientRole == "SuperAdmin" ){
                    return false
                }else if( _.some(permission, {name:"modifyUser" }) ){
                    return true
                }
            }else{
                return false
            }

        break

        case "modifyUser" : 

        

        if(role == "SuperAdmin"){
            
            return true
        }else if(role == "Admin"){
            
            
            if( (typeof options !="undefined" || options != undefined) && _.some(permission, {name:"modifyUser" }) && options.recepientRole == "SuperAdmin" ){
                
                return false
            }else if( _.some(permission, {name:"modifyUser" }) ){
                
                return true
            }
        }else{
            
            return false
        }

        break
        case "modifyShifts" : 

        if(role == "SuperAdmin"){
            return true
        }else if(role == "Admin"){

             if( _.some(permission, {name:"modifyShifts" }) ){
                return true
            }
        }else{
            return false
        }

        break

        case "modifyWeeklyOffs" : 

        if(role == "SuperAdmin"){
            return true
        }if(role == "Admin"){
            if( _.some(permission, {name:"modifyWeeklyOffs" }) )
            {    
                return true
            }
        }else { 
            return false
        }

        break

        case "modifyLocation" : 

        if(role == "SuperAdmin"){
            return true
        }if(role == "Admin"){
            if( _.some(permission, {name:"modifyLocation" }) ){
                return true
            }
        }else{
            return false
        }

        break

        case "modifyHolidays" : 

        if(role == "SuperAdmin"){
            return true
        }else if(role == "Admin"){
            if( _.some(permission, {name:"modifyHolidays" }) ){
                return true
            }
        }else{
            return false
        }

        break

        //Forms
        case "modifyForms" : 
        

        if(role == "SuperAdmin"){
            return true
        }if(role == "Admin"){
            if( _.some(permission, {name:"modifyForms" }) ){
                
                return true
            }
        }else { 
                return false
            }
        
        
        break

        case "modifyTimesheet" : 

        if(role == "SuperAdmin"){
            return true
        }if(role == "Admin"){
            if( _.some(permission, {name:"modifyTimesheet" }) ){
                return true
            }
        }else{
            return false
        }

        break

        case "allowHuddle" : 

        if(role == "SuperAdmin"){
            return true
        }if(role == "Admin"){
            if( _.some(permission, {name:"allowHuddle" }) ){
                console.log("true")
                return true
            }
        }else{
            return false
        }

        break
        
        case "viewKiosk" : 

        if(role == "User"){
            return false
        }
            return true
        

        break

        case "viewPermission" : 

        if(role == "SuperAdmin"){

            return false

        }if(role == "Admin"){
        
                return true
            
        }
            
            return false
        

        break

        case "viewSubscription" : 

        if(role == "SuperAdmin"){

            return true

        }if(role == "Admin"){
        
                return false
            
        }else{
            
            return false
        }

        case "pageView":

            if(role == "Admin")
            {
                if(["Company", "Tags" , "Groups", "Bulk Member", "Bulk Location", "Bulk Holiday", "Bulk Attendance", "Subscription"].includes(options.page))
                {
                    console.log("returning false admin"  )
                    return false
                }    
            }
            else if(role == "User")
            {
                if(!["Help","Setup","Home", "Profile" , "Locations" , "Reports" ,"Forms", "Responses", "Notifications", "Timesheet", "Timesheet Edit", "Field Tracking","Field Tracking Reports","Members","Error", "Bulk Member", "Bulk Location", "Bulk Holiday", "Bulk Attendance"].includes(options.page))
                {
                    console.log("returning false user"  )
                    return false
                }
            }
            console.log("returning true" )
            return true

        break

        

   

    }

    return false


}
export default canSee;
